module.exports = __webpack_public_path__ + "img/banner.c68b9a01.jpg";